<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div>
    <vx-card>
      <div class="flex pb-5">
        <div class="flex-1">
          {{ $t("sections.accounting.dataForm.itemCounts", { max: dataNotificationContractsCall.length }) }}
        </div>
        <div class="flex-1">
          <div class="vx-row">
            <div class="vx-col w-full" style="display: flex; justify-content: flex-end;">
              <div class="mr-1" v-if="dataNotificationContractsCall.length > 0 && isNtfStage2">
                <vs-button @click="sendNotification()">ส่ง Notification แทนการส่ง SMS</vs-button>
              </div>
              <div class="mr-1" v-if="dataNotificationContractsCall.length > 0">
                <vs-button @click="download()">{{ $t("general.download") }}</vs-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vs-table :data="dataNotificationContractsCall">
        <template slot="thead">
          <vs-th>{{ $t("sections.accounting.dataForm.no") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractNo") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.contractName") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.loan.agingNumber") }}</vs-th>
          <vs-th>ส่งฟ้อง</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.loan.payment.paymentDate") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.callHistories.callDate") + "ครั้งที่ 1" }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.sendSmsHistories.sendDate") }}</vs-th>
          <vs-th>{{ $t("sections.accounting.dataForm.callHistories.callDate") + "ครั้งที่ 2"}}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="index" v-for="({id, contractNo, contractSeq, contractName, loan, lawsuitHistories, stage1CallHistories, sendSmsHistories, stage3CallHistories}, index) in data" :state="stageColor({loan, lawsuitHistories, stage1CallHistories, sendSmsHistories})">
            <vs-td>
              {{ index+1 }}
            </vs-td>
            <vs-td>
              <router-link :to="{ name: 'accounting-contract-detail', params: {id}}"> {{ contractNo }} <b><u>{{ contractSeq }}</u></b></router-link>
            </vs-td>
            <vs-td>
              <div style="display: flex; align-items: center;">
                <span>{{ contractName }}</span>
                <vx-tooltip text="สัญญาดังกล่าวเคยใช้งานผ่าน WEL Application แล้ว">
                  <vs-button color="success" type="filled" icon-pack="feather" icon="icon-smartphone" size="small" class="ml-1" v-if="_contractIdsSignInStudentApp.includes(id)"></vs-button>
                </vx-tooltip>
              </div>
            </vs-td>
            <vs-td>
              {{ loan.agingNumber }}
            </vs-td>
            <vs-td>
              {{ lawsuitHistories | lawsuitHistoryFilters }}
              <a @click="$refs.callHistoriesPopup.handlePopup(lawsuitHistories, 'lawsuitHistories')" v-if="lawsuitHistories.length >= 1"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>
            </vs-td>
            <vs-td>
              {{ loan.payments | paymentsFilters }}
              <a @click="$refs.paymentsPopup.handlePopup(loan.payments, 'payments')" v-if="loan.payments.length >= 1"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>
            </vs-td>
            <vs-td>
              {{ stage1CallHistories | callHistoriesFilters }}
              <a @click="$refs.callHistoriesPopup.handlePopup(stage1CallHistories, 'callHistories')" v-if="stage1CallHistories.length >= 1"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>
            </vs-td>
            <vs-td>
              {{ sendSmsHistories | sendSmsHistoriesFilters }}
              <a @click="$refs.sendSmsHistoriesPopup.handlePopup(sendSmsHistories, 'sendSmsHistories')" v-if="sendSmsHistories.length >= 1"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>
            </vs-td>
            <vs-td>
              {{ stage3CallHistories | callHistoriesFilters }}
              <a @click="$refs.callHistoriesPopup.handlePopup(stage3CallHistories, 'callHistories')" v-if="stage3CallHistories.length >= 1"><feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="cursor-pointer"/></a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <custom-popup ref="paymentsPopup" title="รายละเอียดการชำระ"/>
    <custom-popup ref="callHistoriesPopup" title="รายละเอียดการโทร"/>
    <custom-popup ref="sendSmsHistoriesPopup" title="รายละเอียดการส่ง SMS"/>
    <vs-popup
      :active.sync="notificationModal.active"
      title="ส่ง Notification แทนการส่ง SMS"
      class="custom-popup"
    >
      <div class="popup-content">
        <ValidationObserver v-slot="{ handleSubmit }" ref="form">
          <form @submit.prevent="handleSubmit">
            <div class="vx-row">
              <div class="vx-col w-full">
                <validation-provider :name="$t('sections.master.dataForm.notiTempName')" rules="" v-slot="{ errors }">
                  <label class="vs-input--label">{{ $t("sections.master.dataForm.notiTempName") }}</label>
                  <v-select v-model="notificationModal.notificationTemplate" :clearable="true" :options="notificationTemplateOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </validation-provider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <ValidationProvider name="หัวข้อ" rules="required" v-slot="{ errors }" >
                  <label class="text-sm">หัวข้อ*</label>
                  <vs-input type="text" class="w-full" v-model="notificationModal.title"/>
                  <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <label class="text-sm">รายละเอียด*</label>
                <vs-textarea  v-model="notificationModal.description" rows="5"/>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full">
                <p><b>*ดำเนินการส่ง Notification แทนการส่ง SMS ไปยังมือถือของผู้ใช้งานที่เคยเข้าใช้งาน  <label class="text-danger">"WEL Application"</label> เท่านั้น โดยมีจำนวน <label class="text-danger">{{ contractIds.length }}</label> สัญญา (โดยสังเกตุที่หลังเลขที่สัญญาจะมีเครื่องหมายโทรศัพท์)</b></p>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="onPressedAcceptCreateNotificationsForSms">บันทึก</vs-button>
        <vs-button color="danger" @click="notificationModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import {ValidationProvider} from "vee-validate";

const moment = require('moment');

import {createNamespacedHelpers, mapGetters} from 'vuex'

const { mapActions: mapNotificationActions, mapState: mapNotificationState } = createNamespacedHelpers('Notification')
const { mapActions: mapAccountingActions, mapState: mapAccountingState } = createNamespacedHelpers('Accounting')
const { mapActions: mapMasterActions } = createNamespacedHelpers('Master')


import CustomPopup from '@/views/components/custom/Popup'

export default {
  components: {
    CustomPopup,
    vSelect,
    ValidationProvider
  },
  data () {
    return {
      loading: false,
      notificationModal: {
        active: false,
        title: '',
        description: "",
        notificationTemplate: ''
      },
    }
  },
  async created () {
    const vm = this
    const { getNotificationContractsCall, getNotificationTemplateOptions,  getContractIdsSignInStudentApp} = vm;
    await getContractIdsSignInStudentApp();
    await getNotificationTemplateOptions();
    await getNotificationContractsCall({
      action: vm.$route.params.action,
    })
  },
  filters: {
    paymentsFilters: function (objs) {
      try {
        let res = objs[objs.length-1]
        if(moment(res.paymentDate).isValid()){
          return `${moment(res.paymentDate).format("DD-MM-YYYY")}`
        }else{
          return ""
        }
      } catch (error) {
        return ""
      }
    },
    lawsuitHistoryFilters: function (objs) {
      try {
        let res = objs[objs.length-1]
        const { lawsuitDate } = res;
        if(moment(lawsuitDate).isValid()){
          return `${moment(lawsuitDate).format("DD-MM-YYYY")}`
        }else{
          return ""
        }
      } catch (error) {
        return ""
      }
    },
    callHistoriesFilters: function (objs) {
      try {
        let res = objs[objs.length-1]
        const { callDate } = res;
        if(moment(callDate).isValid()){
          return `${moment(callDate).format("DD-MM-YYYY")}`
        }else{
          return ""
        }
      } catch (error) {
        return ""
      }
    },
    sendSmsHistoriesFilters: function (objs) {
      try {
        let res = objs[objs.length-1]
        const { sendDate } = res;
        if(moment(sendDate).isValid()){
          return `${moment(sendDate).format("DD-MM-YYYY")}`
        }else{
          return ""
        }
      } catch (error) {
        return ""
      }
    },
  },
  computed: {
    ...mapNotificationState(['status', 'notificationContractsCall']),
    ...mapAccountingState(['contractIdsSignInStudentApp']),
    ...mapGetters({ notificationTemplateOptions :'Master/notificationTemplateOptions'}),
    dataNotificationContractsCall: function () {
      if(this.notificationContractsCall.length > 0){
        return this.notificationContractsCall
      }
      return this.notificationContractsCall
    },
    _contractIdsSignInStudentApp: function () {
      return this.contractIdsSignInStudentApp
    },
    contractIds: function () {
      return this.notificationContractsCall.filter(item => this.contractIdsSignInStudentApp.includes(item.id)).map(item => item.id)
    },
    isNtfStage2: function () {
      return this.$route.params.action === 'NtfStage2'
    },
  },
  methods: {
    ...mapNotificationActions(['getNotificationContractsCall', 'createNotificationsForSms']),
    ...mapAccountingActions(['getContractIdsSignInStudentApp']),
    ...mapMasterActions(['getNotificationTemplateOptions']),
    stageColor (row) {
      const vm = this;
      const { loan, lawsuitHistories, stage1CallHistories, sendSmsHistories } = row; // stage3CallHistories
      const { payments } = loan;
      const con1 = lawsuitHistories.length === 0; // ไม่มีการส่งฟ้อง
      const con2 = vm.$options.filters.paymentsFilters(payments).length === 0;  // ไม่มีการชำระ
      const con3 = vm.$options.filters.callHistoriesFilters(stage1CallHistories).length === 0;  // ไม่มีการโทรครั้งที่ 1
      const con4 = vm.$options.filters.sendSmsHistoriesFilters(sendSmsHistories).length === 0;  // ไม่มีการส่ง SMS
      // const con5 = this.$options.filters.callHistoriesFilters(stage3CallHistories).length === 0;  // ไม่มีการโทรครั้งที่ 2
      return (con1 && con2 &&  con3) || (con1 && con2 &&  con4) ? '': ''; // danger
    },
    async sendNotification (){
      this.notificationModal.active = true;
    },
    async onPressedAcceptCreateNotificationsForSms() {
      const vm = this
      vm.$refs['form'].validate().then(async success => {
        if (!success) {
          return
        }
        const {createNotificationsForSms, notificationModal, getNotificationContractsCall} = vm;
        const {title, description} = notificationModal;
        await createNotificationsForSms({
          contractIds: vm.contractIds,
          form: {
            title,
            description,
          }
        });
        await getNotificationContractsCall({
          action: vm.$route.params.action,
        })
        vm.notificationModal.active = false;
        vm.notificationModal.title = "";
        vm.notificationModal.description = "";
      })
    },
    async download (){
      const vm = this

      if(!vm.loading){ vm.$vs.loading() }
      vm.loading = false
      setTimeout(() => {
        vm.$vs.loading.close()
      }, 150)
      const headerTitle = [
        this.$t("sections.accounting.dataForm.no"),
        this.$t("sections.accounting.dataForm.contractNo"),
        this.$t("sections.accounting.dataForm.contractName"),
        this.$t("sections.accounting.dataForm.loan.agingNumber"),
        this.$t("sections.accounting.dataForm.loan.payment.paymentDate"),
        "ส่งฟ้อง",
        this.$t("sections.accounting.dataForm.callHistories.callDate") + "ครั้งที่ 1",
        this.$t("sections.accounting.dataForm.sendSmsHistories.sendDate"),
        this.$t("sections.accounting.dataForm.callHistories.callDate") + "ครั้งที่ 2",
      ]
      const headerVal = [
        "no",
        "contractNo",
        "contractName",
        "agingNumber",
        "paymentDate",
        "lawsuit",
        "callDateStage1",
        "sendSmsDate",
        "callDateStage3",
      ]
      const wscols = [
        {wch:5},{wch:16},{wch:27},{wch:20},{wch:20},
        {wch:20},{wch:20},{wch:20}
      ]
      import('@/vendor/Export2Excel').then(async excel => {
        const data = this.formatJson(headerVal, this.notificationContractsCall)
        excel.export_json_to_excel({
          header: headerTitle,
          data,
          filename: `ข้อมูลลูกหนี้ ${moment().format("YYYYMMDDHHmmss")}`,
          autoWidth: false,
          bookType: "xlsx",
          wscols
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map((res, index) => filterVal.map(col => {
        if (col === 'no') {
          return index+1
        } else if ( col === "agingNumber" ) {
          return res.loan.agingNumber
        } else if ( col === "paymentDate" ) {
          if(res.loan.payments.length >= 1){
            let paymentDate = res.loan.payments[res.loan.payments.length-1].paymentDate
            const timestamp = Date.parse(paymentDate);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          }else{
            return "-"
          }
        } else if ( col === "lawsuit" ) {
          const { lawsuitHistories } = res;
          if(lawsuitHistories.length >= 1){
            const { lawsuitDate } = lawsuitHistories[lawsuitHistories.length-1];
            const timestamp = Date.parse(lawsuitDate);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          }else{
            return "-"
          }
        } else if ( col === "callDateStage1" ) {
          const { stage1CallHistories } = res;
          if(stage1CallHistories.length >= 1){
            const { callDate } = stage1CallHistories[stage1CallHistories.length-1];
            const timestamp = Date.parse(callDate);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          }else{
            return "-"
          }
        } else if ( col === "sendSmsDate" ) {
          if(res.sendSmsHistories.length >= 1){
            let sendDate = res.sendSmsHistories[res.sendSmsHistories.length-1].sendDate
            const timestamp = Date.parse(sendDate);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          }else{
            return "-"
          }
        } else if ( col === "callDateStage3" ) {
          const { stage3CallHistories } = res;
          if(stage3CallHistories.length >= 1){
            let { callDate } = stage3CallHistories[stage3CallHistories.length-1];
            const timestamp = Date.parse(callDate);
            let date = "-"
            if (isNaN(timestamp) === false) date = new Date(timestamp);
            return date
          }else{
            return "-"
          }
        } else {
          return res[col]
        }
      }))
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    'notificationModal.notificationTemplate': function(newVal) {
      if(newVal){
        this.notificationModal.title = newVal.title
        this.notificationModal.description = newVal.description
      }else{
        this.notificationModal.title = ""
        this.notificationModal.description = ""
      }
    }
  }
}
</script>

<style scoped>
.vx-row {
  margin-bottom: 15px;
}

.custom-popup .vs-popup {
  width: 600px;
}
.popup-content {
  padding: 10px;
}
.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px;
  border-top: 1px solid #e0e0e0;
}
.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
